import { cn } from '@shared/components/shadcn';
import { Email, Help, Phone } from '@shared/icons';
import type { IconProps } from '@shared/icons/types';
import { useTranslations } from 'next-intl';
import type { FooterContactIconKey, FooterContactSectionConfig } from '../../../../config/footer.types.ts';
import { NavigationPod } from '../../NavigationPod/NavigationPod';
import { HelpCentreChat } from './HelpCentreChat';

type ContactSectionProps = {
  config: FooterContactSectionConfig;
};

function renderContactIcon(iconKey: FooterContactIconKey): React.ComponentType<IconProps> {
  switch (iconKey) {
    case 'Email':
      return Email;
    case 'Phone':
      return Phone;
    case 'Help':
    default:
      return Help;
  }
}

function ContactSection({ config }: ContactSectionProps) {
  const t = useTranslations('footer.contact_information');
  const { items } = config;
  const adjustToRowOnDesktop = items.length > 3;

  return (
    <div className="flex flex-col gap-4 xl:flex-row xl:flex-wrap xl:items-stretch" data-track-container="Contacts">
      {items.map((item, index) => (
        <div key={index} className={cn('w-full min-w-0 xl:self-stretch', adjustToRowOnDesktop ? 'xl:flex-1' : 'xl:w-auto')}>
          {item.type === 'chat' ? (
            <HelpCentreChat label={t(item.labelKey)} data-track-name={item.trackName} />
          ) : (
            <NavigationPod
              href={item.href}
              variant="contact"
              icon={renderContactIcon(item.iconKey)}
              label={t(item.labelKey)}
              secondaryLabel={item.secondaryLabelKey ? t(item.secondaryLabelKey) : undefined}
              data-track-name={item.trackName}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export { ContactSection };
